<vex-page-layout>
  
  <vex-page-layout-content class="-mt-6">
    <mat-accordion>
      <mat-expansion-panel >
        <mat-expansion-panel-header>
          <mat-panel-title>
            {{ 'DOWNLOAD_REPORT.TEXT' | translate }}
          </mat-panel-title>
        </mat-expansion-panel-header>
        <div class="flex flex-wrap items-center gap-4 p-4">
          <mat-form-field >
            <mat-label>{{ 'STATUS.TEXT' | translate }}</mat-label>
            <mat-select [(ngModel)]="reportStatus">
              <mat-option *ngFor="let status of loadingOrderStatusOptions" [value]="status.value">
                {{ status.labelKey | translate }}
              </mat-option>
            </mat-select>
          </mat-form-field>
          <mat-form-field >
            <mat-label>{{ 'FROM_DATE.TEXT' | translate }}</mat-label>
            <input matInput [matDatepicker]="fromPicker" [(ngModel)]="reportFromDate">
            <mat-datepicker-toggle matSuffix [for]="fromPicker"></mat-datepicker-toggle>
            <mat-datepicker #fromPicker></mat-datepicker>
          </mat-form-field>
          <mat-form-field>
            <mat-label>{{ 'TO_DATE.TEXT' | translate }}</mat-label>
            <input matInput [matDatepicker]="toPicker" [(ngModel)]="reportToDate">
            <mat-datepicker-toggle matSuffix [for]="toPicker"></mat-datepicker-toggle>
            <mat-datepicker #toPicker></mat-datepicker>
          </mat-form-field>
          <button mat-raised-button color="primary" (click)="downloadReport()">
            {{ 'DOWNLOAD_REPORT.TEXT' | translate }}
          </button>
        </div>
      </mat-expansion-panel>
    </mat-accordion>
    <div class="card">
      <div class="bg-app-bar px-6 h-16 border-b left-0 flex items-center">
        <h2
          class="title my-0 ltr:pr-4 rtl:pl-4 ltr:mr-4 rtl:ml-4 ltr:border-r rtl:border-l hidden sm:block flex-none">
          <span *ngIf="dataSource?.data?.length == 1">{{
            "LOADING_ORDER.TEXT" | translate
          }}</span>
          <span *ngIf="dataSource?.data?.length > 1">{{
            "LOADING_ORDER.TEXT" | translate
          }}</span>
        </h2>

        <!-- <div *ngIf="selection.hasValue()" class="mr-4 pr-4 border-r flex-none">
          <button
              *ngIf="canDelete"
              (click)="deleteVehicles(selection.selected)"
              color="primary"
              mat-icon-button
              [matTooltip]="'DELETE_SELECTED.TEXT' | translate"
              type="button">
            <mat-icon svgIcon="mat:delete"></mat-icon>
          </button>
        </div> -->

        <div
          class="rounded border border-black px-4 flex-auto flex items-center mat-table-search-input">
          <mat-icon
            class="icon-sm text-secondary"
            svgIcon="mat:search"></mat-icon>
          <input
            [formControl]="searchCtrl"
            class="px-4 py-2 border-0 outline-none w-full bg-transparent"
            [placeholder]="'SEARCH.TEXT' | translate"
            type="search" />
        </div>

        <span class="flex-1"></span>
        <span class="flex-1"></span>
        <span class="flex-1"></span>

        <!-- <button
          [matMenuTriggerFor]="columnFilterMenu"
          class="ml-4 flex-none"
          mat-icon-button
          [matTooltip]="'FILTER_COLUMNS.TEXT' | translate"
          type="button">
          <mat-icon svgIcon="mat:filter_list"></mat-icon>
        </button> -->

        <!-- <button
            class="ml-4 flex-none"
            color="primary"
            mat-mini-fab
            [matTooltip]="'ADD_LOADING_ORDER.TEXT' | translate"
            routerLink="/transactions/add-loading-order"
            type="button">
            <mat-icon svgIcon="mat:add"></mat-icon>
          </button> -->
      </div>

      <mat-progress-bar
        mode="indeterminate"
        *ngIf="isLoading"></mat-progress-bar>

      <div class="table-container">
        <table
          @stagger
          [dataSource]="dataSource"
          class="mat-elevation-z8 mat-table-fixed"
          mat-table
          matSort>
          <!-- Checkbox Column -->
          <!-- <ng-container matColumnDef="checkbox">
            <th *matHeaderCellDef mat-header-cell>
              <mat-checkbox
                (change)="$event ? masterToggle() : null"
                [checked]="selection.hasValue() && isAllSelected()"
                [indeterminate]="selection.hasValue() && !isAllSelected()"
                color="primary">
              </mat-checkbox>
            </th>
            <td *matCellDef="let row" class="w-4" mat-cell>
              <mat-checkbox
                (change)="$event ? selection.toggle(row) : null"
                (click)="$event.stopPropagation()"
                [checked]="selection.isSelected(row)"
                color="primary">
              </mat-checkbox>
            </td>
          </ng-container> -->

          <!-- Text Columns -->
          <ng-container
            *ngFor="let column of columns; trackBy: trackByProperty">
            <ng-container
              *ngIf="column.type === 'text' && column.property != 'status'"
              [matColumnDef]="column.property">
              <th *matHeaderCellDef mat-header-cell mat-sort-header>
                {{ column.label | translate }}
              </th>
              <td *matCellDef="let row" [ngClass]="column.cssClasses" mat-cell>
                {{ row[column.property] }}
              </td>
            </ng-container>
          </ng-container>

          <!-- Status Column -->
          <!-- Status Column -->
          <ng-container matColumnDef="status">
            <th mat-header-cell *matHeaderCellDef>
              {{ "STATUS.TEXT" | translate }}
            </th>
            <td mat-cell *matCellDef="let row">
              <span
                *ngIf="row.InProgress"
                class="status-badge status-under-approval">
                {{ "IN_PROGRESS.TEXT" | translate }}
              </span>
              <span
                *ngIf="row.isProcessing"
                class="status-badge status-under-approval">
                {{ "LOADING_ORDER_PROCESSING.TEXT" | translate }}
              </span>
              <span
                *ngIf="row.isCompeleted"
                class="status-badge status-completed">
                {{ "COMPLETED.TEXT" | translate }}
              </span>
              <!-- <span *ngIf="row.isApproved" class="status-badge status-approved">
                {{ "APPROVED.TEXT" | translate }}
              </span> -->
              <span *ngIf="row.isSynced" class="status-badge status-synced">
                {{ "SYNCED.TEXT" | translate }}
              </span>
              <span *ngIf="row.isDraft" class="status-badge status-draft">
                {{ "DRAFT.TEXT" | translate }}
              </span>
              <span
                *ngIf="row.isCancelled"
                class="status-badge status-cancelled">
                {{ "CANCELLED.TEXT" | translate }}
              </span>
            </td>
          </ng-container>

          <!-- Contact Column -->
          <ng-container matColumnDef="contact">
            <th *matHeaderCellDef mat-header-cell mat-sort-header></th>
            <td *matCellDef="let row" mat-cell>
              <div class="flex">
                <a
                  (click)="$event.stopPropagation()"
                  class="w-8 h-8 leading-none flex items-center justify-center hover:bg-hover text-primary bg-primary/10"
                  mat-icon-button>
                  <mat-icon class="icon-sm" svgIcon="mat:phone"></mat-icon>
                </a>

                <a
                  (click)="$event.stopPropagation()"
                  class="w-8 h-8 leading-none flex items-center justify-center ml-1 hover:bg-hover text-teal bg-teal-light"
                  mat-icon-button>
                  <mat-icon class="icon-sm" svgIcon="mat:mail"></mat-icon>
                </a>

                <a
                  (click)="$event.stopPropagation()"
                  class="w-8 h-8 leading-none flex items-center justify-center ml-1 hover:bg-hover text-green bg-green-light"
                  mat-icon-button>
                  <mat-icon class="icon-sm" svgIcon="mat:map"></mat-icon>
                </a>
              </div>
            </td>
          </ng-container>

          <!-- Label Column -->
          <ng-container matColumnDef="labels">
            <th *matHeaderCellDef mat-header-cell mat-sort-header>Labels</th>
            <td *matCellDef="let row" mat-cell>
              <div
                (click)="$event.stopPropagation()"
                class="flex items-center gap-1">
                <div
                  *ngFor="let label of row.labels"
                  [ngClass]="[label.textClass, label.bgClass]"
                  class="rounded px-2 py-1 font-medium text-xs flex-none ms-1 me-1">
                  {{ label.text }}
                </div>
                <div
                  (click)="labelSelect.open()"
                  class="text-secondary bg-base text-hint cursor-pointer hover:bg-hover flex-none flex items-center justify-center">
                  <mat-icon class="icon-sm" svgIcon="mat:add"></mat-icon>
                </div>
                <mat-select
                  #labelSelect="matSelect"
                  [value]="row.labels"
                  class="invisible w-0 h-0 text-sm shrink"
                  multiple>
                  <mat-option *ngFor="let label of labels" [value]="label">
                    <div
                      [ngClass]="label.previewClass"
                      class="h-6 w-6 align-middle ltr:mr-2 rtl:ml-2 rounded inline-block"></div>
                    <span>{{ label.text }}</span>
                  </mat-option>
                </mat-select>
              </div>
            </td>
          </ng-container>

          <!-- Action Column -->
          <ng-container matColumnDef="actions">
            <th *matHeaderCellDef mat-header-cell mat-sort-header>
              {{ "ACTIONS.TEXT" | translate }}
            </th>
            <td *matCellDef="let row" class="w-10 text-secondary" mat-cell>
              <div class="action-icons">
                <button
                   id="grayIcon"
                  class="hover:bg-hover cursor-pointer"
                  (click)="viewLoadingOrder(row)"
                  type="button"
                  matTooltip="{{ 'VIEW.TEXT' | translate }}">
                  <mat-icon
                    class="bg-green-light"
                    svgIcon="mat:visibility"></mat-icon>
                </button>

                <ng-container *ngIf="canEdit">
                  <button
                *ngIf="row.InProgress || row.isDraft || row.isProcessing"
                   id="grayIcon"
                  class="hover:bg-hover cursor-pointer"
                  (click)="updateLoadingOrder(row)"
                  type="button"
                  matTooltip="{{ 'EDIT.TEXT' | translate }}">
                  <mat-icon
                    class="bg-green-light"
                    svgIcon="mat:edit"></mat-icon>
                </button>
                </ng-container>
                
                <button
                  *ngIf="row.isProcessing"
                  id="grayIcon"
                  class="hover:bg-hover cursor-pointer"
                  (click)="approveLoadingOrder(row)"
                  type="button"
                  matTooltip="{{ 'APPROVE.TEXT' | translate }}">
                  <mat-icon class="grayIcon" svgIcon="mat:check"></mat-icon>
                </button>
                <ng-container *ngIf="canDelete">
                  <button
                *ngIf="row.InProgress || row.isDraft || row.isProcessing"
                  id="grayIcon"
                  class="hover:bg-hover cursor-pointer"
                  (click)="deleteLoadingOrder(row)"
                  type="button"
                  matTooltip="{{ 'DELETE.TEXT' | translate }}">
                  <mat-icon class="grayIcon" svgIcon="mat:delete"></mat-icon>
                </button>
                </ng-container>
                
              </div>
            </td>
          </ng-container>

          <tr *matHeaderRowDef="visibleColumns" mat-header-row></tr>
          <!-- (click)="updateTRANSPORTER(row)" -->

          <tr
            *matRowDef="let row; columns: visibleColumns"
            @fadeInUp
            class="hover:bg-hover trans-ease-out cursor-pointer"
            mat-row></tr>
        </table>
      </div>

      <!-- Contact Column -->
      <ng-container matColumnDef="contact">
        <th *matHeaderCellDef mat-header-cell mat-sort-header></th>
        <td *matCellDef="let row" mat-cell>
          <div class="flex">
            <a
              (click)="$event.stopPropagation()"
              class="w-8 h-8 leading-none flex items-center justify-center hover:bg-hover text-primary bg-primary/10"
              mat-icon-button>
              <mat-icon class="icon-sm" svgIcon="mat:phone"></mat-icon>
            </a>

            <a
              (click)="$event.stopPropagation()"
              class="w-8 h-8 leading-none flex items-center justify-center ml-1 hover:bg-hover text-teal bg-teal-light"
              mat-icon-button>
              <mat-icon class="icon-sm" svgIcon="mat:mail"></mat-icon>
            </a>

            <a
              (click)="$event.stopPropagation()"
              class="w-8 h-8 leading-none flex items-center justify-center ml-1 hover:bg-hover text-green bg-green-light"
              mat-icon-button>
              <mat-icon class="icon-sm" svgIcon="mat:map"></mat-icon>
            </a>
          </div>
        </td>
      </ng-container>

      <ng-container *ngFor="let column of columns; trackBy: trackByProperty">
        <ng-container [matColumnDef]="column.property">
          <th *matHeaderCellDef mat-header-cell mat-sort-header>
            {{ column.label }}
          </th>
          <td *matCellDef="let row" [ngClass]="column.cssClasses" mat-cell>
            {{ row[column.property] }}
          </td>
        </ng-container>
      </ng-container>

      <!-- Label Column -->
      <ng-container matColumnDef="labels">
        <th *matHeaderCellDef mat-header-cell mat-sort-header>Labels</th>
        <td *matCellDef="let row" mat-cell>
          <div
            (click)="$event.stopPropagation()"
            class="flex items-center gap-1">
            <div
              *ngFor="let label of row.labels"
              [ngClass]="[label.textClass, label.bgClass]"
              class="rounded px-2 py-1 font-medium text-xs flex-none ms-1 me-1">
              {{ label.text }}
            </div>
            <div
              (click)="labelSelect.open()"
              class="text-secondary bg-base text-hint cursor-pointer hover:bg-hover flex-none flex items-center justify-center">
              <mat-icon class="icon-sm" svgIcon="mat:add"></mat-icon>
            </div>
            <mat-select
              #labelSelect="matSelect"
              [value]="row.labels"
              class="invisible w-0 h-0 text-sm shrink"
              multiple>
              <mat-option *ngFor="let label of labels" [value]="label">
                <div
                  [ngClass]="label.previewClass"
                  class="h-6 w-6 align-middle ltr:mr-2 rtl:ml-2 rounded inline-block"></div>
                <span>{{ label.text }}</span>
              </mat-option>
            </mat-select>
          </div>
        </td>
      </ng-container>

      <!-- Action Column -->
      <ng-container matColumnDef="actions">
        <th *matHeaderCellDef mat-header-cell mat-sort-header>
          {{ "ACTIONS.TEXT" | translate }}
        </th>
        <td *matCellDef="let row" class="w-10 text-secondary" mat-cell>
          <div class="action-icons">
            <button
              id="editIcon"
              class="hover:bg-hover cursor-pointer"
              type="button"
              matTooltip="{{ 'EDIT.TEXT' | translate }}">
              <mat-icon svgIcon="mat:edit"></mat-icon>
            </button>
            <button
              id="deleteIcon"
              class="hover:bg-hover cursor-pointer"
              type="button"
              matTooltip="{{ 'DELETE.TEXT' | translate }}">
              <mat-icon svgIcon="mat:delete"></mat-icon>
            </button>
          </div>
        </td>
      </ng-container>

      <tr *matHeaderRowDef="visibleColumns" mat-header-row></tr>

      <tr
        *matRowDef="let row; columns: visibleColumns"
        @fadeInUp
        class="hover:bg-hover trans-ease-out cursor-pointer"
        mat-row></tr>
    </div>
    <mat-paginator
        [pageSizeOptions]="pageSizeOptions"
        [pageSize]="pageSize"
        [length]="totalRows"
        [pageIndex]="currentPage"
        (page)="pageChanged($event)"
        class="sticky left-0"></mat-paginator>
  </vex-page-layout-content>
</vex-page-layout>

<!-- <div [ngClass]="{ rtl: isRtl }">
  <mat-menu #columnFilterMenu="matMenu" xPosition="before" yPosition="below">
    <div class="scroll-container">
      <button
        (click)="toggleColumnVisibility(column, $event)"
        *ngFor="let column of columns"
        class="checkbox-item mat-menu-item">
        <mat-checkbox
          (click)="$event.stopPropagation()"
          [(ngModel)]="column.visible"
          color="primary">
          {{ column.label }}
        </mat-checkbox>
      </button>
    </div>
  </mat-menu>
</div> -->

<mat-menu #actionsMenu="matMenu" xPosition="before" yPosition="below">
  <ng-template let-customer="customer" matMenuContent>
    <button mat-menu-item>
      <mat-icon svgIcon="mat:edit"></mat-icon>
      <span>{{ "EDIT.TEXT" | translate }}</span>
    </button>
    <button mat-menu-item>
      <mat-icon svgIcon="mat:delete"></mat-icon>
      <span>{{ "DELETE.TEXT" | translate }}</span>
    </button>
  </ng-template>
</mat-menu>
